import { filter } from 'ramda'

import { BuildingId, OrgDishId, OrgId, WarehouseStockItemId } from 'app/common/types/id'
import { WarehouseStockAdjustParams, WarehouseStockItem } from 'app/common/types/warehouse/stock'

import type { Request } from '../../../../../index'

type PathParamsDto = {
  id: string
}

type ParamsDto = {
  new_quantity: number
  reason?: string
}

type ResultDto = {
  id: number
  product_id: number
  product_title: string
  product_units: string
  quantity: number
  school_id: number
  building_id: number | null
}

export const convertParams = ({
  id,
  newQuantity,
  reason,
}: WarehouseStockAdjustParams): [ParamsDto, PathParamsDto] => {
  return [
    filter((val) => val !== undefined, {
      new_quantity: newQuantity,
      reason: reason,
    }),
    { id },
  ]
}

export const convertResult = ({
  id,
  product_id: productId,
  product_title: title,
  product_units: unit,
  quantity,
  school_id: orgId,
  building_id: buildingId,
}: ResultDto): WarehouseStockItem => {
  return {
    id: String(id) as WarehouseStockItemId,
    productId: String(productId) as OrgDishId,
    title,
    unit,
    quantity,
    orgId: String(orgId) as OrgId,
    buildingId: buildingId ? (String(buildingId) as BuildingId) : null,
  }
}

export const PATCH_WAREHOUSE_STOCK_ITEM: Request<
  WarehouseStockAdjustParams,
  WarehouseStockItem,
  PathParamsDto
> = ['food/warehouse/stock/{id}/adjust', 'patch', ['data', 'stock_item']]
